import login from '../login/index'
import resetPassword from '../resetPassword/index'
import layout from '../layout/index'
import menu from '../menu/index'
import machines from 'MACHINEMODULE'
import machinesCommon from '../machines/common'
import machinesProgressives from '../machines.progressives'
import workorders from '../work-orders/index'
import utils from '../utils/index'
import parts from '../parts/index'
import contactBook from '../ContactBook/index'
import ui from '../ui/index'
import users from '../user/index'
import { moduleName as recordsModuleName } from '../records'
import { vsName as userProfileModuleName } from '../application/userProfileModule'


import uiRouter from '@uirouter/angularjs/lib-esm'
/* ui-select doesn't export module.  Run this for side effects and manually include below*/
import 'ui-select/dist/select'
import ngAnimate from 'angular-animate'
import ngMessages from 'angular-messages'
import uiBootstrap from 'angular-ui-bootstrap'
import uiBootstrapDatetimepicker from 'bootstrap-ui-datetime-picker'

import uiDefaults from './ConfigUiDefaults'
import httpResponseDateConverterInterceptor from './httpResponseDateConverterInterceptor'
import baseUrlInterceptor from './baseUrlInterceptor'
//import authenticationHttpInterceptor from './authentication/httpInterceptor'
import { httpUnauthenticatedInterceptorRegistrationFunction, HttpUnauthenticatedInterceptorService, vsName as httpUnauthenticatedInterceptorName } from './authentication/httpUnauthenticatedInterceptorService'
import uiRouterAuthentication from './authentication/uiRouter'

var dependencies = [
  login,
  resetPassword,
  layout,
  menu,
  machinesCommon,
  machines,
  machinesProgressives,
  workorders,
  recordsModuleName,
  users,
  workorders,
  utils,
  parts,
  contactBook,
  ui,
  uiRouter,
  'ui.select',
  ngAnimate,
  ngMessages,
  'lr.upload',
  uiBootstrap,
  uiBootstrapDatetimepicker,
  userProfileModuleName
]

var app = angular.module('SlotTrak', dependencies)

app
  .config(Config)
  .config(uiDefaults)
  .run(Run)
  .run(uiRouterAuthentication)
  .service(httpUnauthenticatedInterceptorName, HttpUnauthenticatedInterceptorService)

Run.$inject = ['$rootScope', '$log', 'applicationInfo', '$transitions', '$state']
function Run($rootScope, $log, applicationInfo, $transitions, $state) {
  $state.onInvalid((to, from, injector) => {
    $log.warn({
      to,
      from,
      injector
    })

    return from
  })

  $transitions.onError({}, transition => {
    const error = transition.error()
    if (!error.redirected) {
      $log.warn(error)
    } else {
      $log.debug(error)
    }
  })

  $transitions.onStart({}, transition => {
    $log.debug(transition)
  })

  $rootScope.isModuleLoaded = function isModuleLoaded(name) {
    return applicationInfo.isModuleLoaded(name)
  }

  $rootScope.isFeatureEnabled = function isFeatureEnabled(name){
    return applicationInfo.isFeatureEnabled(name)
  }
}

Config.$inject = ['$httpProvider', '$locationProvider', '$urlRouterProvider', '$logProvider', '$compileProvider']
function Config($httpProvider, $locationProvider, $urlRouterProvider, $logProvider, $compileProvider) {
  $httpProvider.interceptors.push(httpResponseDateConverterInterceptor)
  $httpProvider.interceptors.push(httpUnauthenticatedInterceptorRegistrationFunction)
  $httpProvider.interceptors.push(baseUrlInterceptor)

  var headers = $httpProvider.defaults.headers
  headers.common.Accept = 'application/json/;text/json;*/*'
  headers.common['Content-Type'] = 'application/json; charset=utf-8'

  $urlRouterProvider.otherwise('/machines')
  $locationProvider.html5Mode({
    enabled: true
  })
  $logProvider.debugEnabled(false)
  $compileProvider.debugInfoEnabled = false
}

export default app.name